import React from 'react';
import { SafeAreaTopSpacing, StackScreen } from '@banhala/ui-kit';
import { WebView } from 'shared/src/component/WebWebView';
import { useWebBaseURL } from 'shared/src/hooks';
import { isNotNil } from 'shared/src/utils';

export const ContentsScreen: React.FC = () => {
  const webBaseUrl = useWebBaseURL();

  return (
    <StackScreen title={'플레이스'} hideBackButton={true} hideHeader={true}>
      <SafeAreaTopSpacing />
      {isNotNil(webBaseUrl) && (
        <WebView
          style={{ flex: 1 }}
          source={{ uri: `${webBaseUrl}/place/home?global_layout=app` }}
        />
      )}
    </StackScreen>
  );
};
